(ns minorodata.components.connections.connections-list
  (:require ["lucide-react" :refer [Search]]
            [applied-science.js-interop :as js-interop]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.app.shared-events]
            [minorodata.app.utils :as app.utils]
            [minorodata.components.connections.connector-filters :as connector-filters]
            [minorodata.components.spinner.core :as c.spinner]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            [ui.button :refer [button]]
            [ui.card :refer [card]]
            [ui.fields :as fields]
            [ui.tabs]
            [ui.typography :as typography]))

;; Displays a single source in the list of sources
(defn connection [{:keys [image title description on-click enabled id by-request class]}]
  [card {:class [class "overflow-hidden"]}
   [:div {:class   "h-full flex flex-col"
          :data-cy (str "connection-card-" id)}
    [:button {:class    "border-b bg-white hover:bg-kleene-neutral-05 transition-colors"
              :on-click #(when enabled (on-click))}
     [:div {:class "flex items-center justify-center aspect-video w-5/6 mx-auto p-3 "}
      [:img {:src image
             :alt title
             :class "max-w-full h-[100px] object-contain"
             :loading "lazy"}]]]
    [:div {:class "grow p-4 flex flex-col gap-2"}
     [typography/h3 title]
     [typography/p {:class "text-kleene-text-secondary text-xs leading-relaxed"} description]]

    [:div {:class "p-2 flex items-center"}
     (when enabled
       [button {:size     :small
                :variant  :link
                :data-cy (str "connection-card-" id "-connect")
                :on-click on-click}
        (if by-request "Available By Request" "Connect")])

     (when-not enabled
       [button {:size     "small"
                :color    "primary"
                :disabled true}
        "Not enabled"])]]])

;; Page showing interactive list of connections + form to add new ones
(defn connections-list []
  (let [tag            (reagent/atom "all")
        search-term    (reagent/atom "")]
    (reagent/create-class
     {:display-name "connections-list"

      :component-did-mount
      (fn []
        (dispatch [:connections.api/fetch-user-connectors]))

      :render
      (fn []
        (let [loading?           @(re-posh/subscribe [:mold-http/loading? :connections.api/fetch-user-connectors])
              all-connectors     @(re-posh/subscribe [:connections.subs/current-connectors])
              sources-to-display (-> (connector-filters/filter-sources all-connectors @tag)
                                     connector-filters/filter-enabled
                                     (connector-filters/search-sources @search-term)
                                     connector-filters/sort-sources)]
          [:div {:class "-mx-6 -mt-4 min-w-full"}
           [:div {:class "sticky px-6 py-2 mt-2 top-16 flex gap-2 justify-between z-10 bg-kleene-background-secondary"}
            [ui.tabs/tabs {:value           @tag
                           :classes         {:root    "overflow-x-auto scrollbar-dark dark:scrollbar py-px scrollbar-thin"
                                             :trigger "shrink-0 bg-kleene-background"}
                           :data-cy         "connections-connectors-filter"
                           :on-value-change #(reset! tag %)
                           :tabs            connector-filters/connector-tabs}]
            [:div
             [fields/input {:placeholder "Search..."
                            :icon        Search
                            :data-cy     "connections-connectors-filter"
                            :on-change
                            (fn [e]
                              (let [value (js-interop/get-in e [:target :value])]
                                (reset! search-term value)))}]]]

           (if loading?
             [:div {:class "m-10 flex gap-4 items-center justify-center"}
              [c.spinner/spinner-lucide {:size 32}]
              [typography/p "Loading connectors..."]]

             [:div {:class "px-6 py-2 h-full overflow-y-auto pb-[70px]"}
              [:div {:class   "grid gap-4 items-stretch"
                     :style {:grid-template-columns "repeat(auto-fill, minmax(250px, 1fr))"}
                     :data-cy "connections-connectors-list"}

               (when (empty? sources-to-display)
                 [typography/p "No matching sources found."])

               (for [conn sources-to-display
                     :let [{:keys [image-source id name enabled
                                   description by-request]} conn]]
                 ^{:key id}
                 [connection {:image       (app.utils/maybe-local-url image-source)
                              :id          id
                              :title       name
                              :on-click    #(dispatch [:connector/add {:connector/action :create-source
                                                                       :connector/type   id}])
                              :enabled     enabled
                              :description description
                              :by-request  by-request}])]])]))})))
